<template>
  <v-container fluid>
    <v-row no-gutters class="pa-1">
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="260">
        <i-card-vertical headerTitle="button" class="fill-height">
          <template v-slot:body>
            <v-row class="pt-5">
              <v-btn class="ma-1 pa-1" color="primary">Primary</v-btn>
              <v-btn class="ma-1 pa-1" color="secondary">Secondary</v-btn>
              <v-btn class="ma-1 pa-1" color="success">Success</v-btn>
              <v-btn class="ma-1 pa-1" color="error">Error</v-btn>
              <v-btn class="ma-1 pa-1" color="warning">Warning</v-btn>
            </v-row>
            <v-row>
              <v-btn class="ma-1 pa-1" outlined color="primary">Primary</v-btn>
              <v-btn class="ma-1 pa-1" outlined color="secondary">Secondary</v-btn>
              <v-btn class="ma-1 pa-1" outlined color="success">Success</v-btn>
              <v-btn class="ma-1 pa-1" outlined color="error">Error</v-btn>
              <v-btn class="ma-1 pa-1" outlined color="warning">Warning</v-btn>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="260">
        <i-card-vertical headerTitle="radio" class="fill-height">
          <template v-slot:body>
            <v-row>
              <v-radio-group class="ma-1 pa-1" v-model="radioGroup" row mandatory>
                <v-radio label="Radio 1" value="radio-1"></v-radio>
                <v-radio label="Radio 2" value="radio-2"></v-radio>
                <v-radio label="Radio 3" value="radio-3"></v-radio>
              </v-radio-group>
              <p class="ma-1 pa-1 primary--text">{{ radioGroup || 'null' }}</p>
              <p :class="radioColor">{{ radioColorGroup || 'null' }}</p>
            </v-row>
            <v-row>
              <v-radio-group class="ma-1 pa-1" v-model="radioColorGroup" row mandatory>
                <v-radio label="primary" color="primary" value="primary"></v-radio>
                <v-radio label="secondary" color="secondary" value="secondary"></v-radio>
                <v-radio label="success" color="success" value="success"></v-radio>
                <v-radio label="error" color="error" value="error"></v-radio>
                <v-radio label="warning" color="warning" value="warning"></v-radio>
              </v-radio-group>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="260">
        <i-card-vertical headerTitle="checkBox" class="fill-height">
          <template v-slot:body>
            <v-row>
              <v-checkbox class="pa-2 pb-0" v-model="checkbox" :label="`Checkbox 1: ${checkbox.toString()}`"></v-checkbox>
              <v-checkbox class="pa-2 pb-0" v-model="checkbox" label="disabled" disabled></v-checkbox>
            </v-row>
            <v-row>
              <v-checkbox class="pa-2 pb-0" v-model="ex1" label="primary" color="primary" hide-details> </v-checkbox>
              <v-checkbox class="pa-2 pb-0" v-model="ex2" label="secondary" color="secondary" hide-details></v-checkbox>
              <v-checkbox class="pa-2 pb-0" v-model="ex3" label="success" color="success" hide-details> </v-checkbox>
              <v-checkbox class="pa-2 pb-0" v-model="ex4" label="error" color="error" hide-details> </v-checkbox>
              <v-checkbox class="pa-2 pb-0" v-model="ex5" label="warning" color="warning" hide-details> </v-checkbox>
            </v-row>
            <v-row>
              <v-checkbox class="mt-5 pl-2 pb-5 pt-0" v-model="checkboxEnable" hide-details> </v-checkbox>
              <v-text-field :disabled="!checkboxEnable" :label="$t('enableCheckbox')"></v-text-field>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-1">
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="500">
        <i-card-vertical headerTitle="selectBox" class="fill-height">
          <template v-slot:body>
            <v-row>
              <v-select class="pa-2" :items="selectList" label="Standard"></v-select>
              <v-select class="pa-2" :items="selectList" label="Solo" solo background-color="transparent"> </v-select>
            </v-row>
            <v-row>
              <v-select class="pa-2" :items="selectList" label="Outlined" outlined></v-select>
              <v-select class="pa-2" :items="selectList" label="Filled" filled></v-select>
            </v-row>
            <v-row>
              <v-select class="pa-2" :items="selectList" label="Disabled" disabled></v-select>
            </v-row>
            <v-row>
              <v-select class="pa-2" :items="selectList" label="Multiple" multiple chips></v-select>
            </v-row>
            <v-row>
              <v-select class="pa-2" :items="selectList" label="Icon" prepend-icon="$person"> </v-select>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="500">
        <i-card-vertical headerTitle="input" class="fill-height">
          <template v-slot:body>
            <v-row>
              <v-text-field
                class="pa-2"
                label="Required name"
                v-model="name"
                :rules="[() => !!name || 'This name is required']"
                hide-details="auto"
                placeholder="Placeholder"
              />
              <v-text-field class="pa-2" label="Solo" solo hide-details="auto" background-color="transparent" placeholder="Placeholder" />
            </v-row>
            <v-row>
              <v-text-field class="pa-2" label="Outlined" outlined hide-details="auto" placeholder="Placeholder" suffix="kg" />
              <v-text-field class="pa-2" label="Filled" filled hide-details="auto" placeholder="Placeholder" single-line />
            </v-row>
            <v-row>
              <v-text-field class="pa-2" label="Solo" solo prepend-inner-icon="$person" background-color="transparent" />
              <v-text-field class="pa-2" label="Solo" solo append-icon="$person" background-color="transparent" />
            </v-row>
            <v-row>
              <v-text-field
                class="pa-2"
                v-model="password"
                :append-icon="pwShow ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[() => !!password || 'This password is required']"
                :type="pwShow ? 'text' : 'password'"
                name="input-10-1"
                label="Password"
                counter
                @click:append="pwShow = !pwShow"
              ></v-text-field>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
      <v-col cols="12" sm="12" lg="4" class="pr-1 pl-1" min-height="500">
        <i-card-vertical headerTitle="dialog" class="fill-height">
          <template v-slot:body>
            <v-row justify="center">
              <v-dialog v-model="fullDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1 pa-2" color="primary" v-bind="attrs" v-on="on">
                    Fullscreen
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar color="primary">
                    <v-btn icon dark @click="fullDialog = false">
                      <v-icon>$close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Fullscreen Dialog</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click="fullDialog = false">
                        Close
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog v-model="infoDialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1 pa-2" color="secondary" v-bind="attrs" v-on="on">
                    InfoDialog
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Info Dialog
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="infoDialog = false">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog v-model="okcanDialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1 pa-2" color="third" v-bind="attrs" v-on="on">
                    Ok&Cancel Dialog
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Ok&Cancel Dialog
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="okcanDialog = false">
                      OK
                    </v-btn>
                    <v-btn color="error" text @click="okcanDialog = false">
                      CANCEL
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-btn :disabled="loadingDialog" :loading="loadingDialog" class="ma-1 pa-2" color="success" @click="loadingDialog = true">
                Start loading
              </v-btn>
              <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                  <v-card-text>
                    Loding...
                    <v-progress-linear indeterminate color="i_title" class="mb-0"> </v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
export default {
  name: 'controlTab',
  components: {
    'i-card-vertical': iCardVertical
  },
  card_title: function() {
    return this.$vuetify.theme.themes.light.card_title
  },
  sub_title: function() {
    return this.$vuetify.theme.themes.light.sub_title
  },
  content: function() {
    return this.$vuetify.theme.themes.light.content
  },
  app_bar_bg: function() {
    return this.$vuetify.theme.themes.light.app_bar_bg
  },
  nav_bg: function() {
    return this.$vuetify.theme.themes.light.nav_bg
  },
  menu_bg: function() {
    return this.$vuetify.theme.themes.light.menu_bg
  },
  //tabviewbg //2022-03-17 by lyj tabview테마적용 start2
  tabview_bg: function() {
    return this.$vuetify.theme.themes.light.tabview_bg
  },
  tabview_active_text: function() {
    return this.$vuetify.theme.themes.light.tabview_active_text
  },
  tabview_text: function() {
    return this.$vuetify.theme.themes.light.tabview_text
  },
  //tabviewbg //2022-03-17 by lyj tabview테마적용 end
  container_bg: function() {
    return this.$vuetify.theme.themes.light.container_bg
  },
  card_bg: function() {
    return this.$vuetify.theme.themes.light.card_bg
  },
  computed: {
    primary: function() {
      return this.$vuetify.theme.themes.light.primary
    },
    secondary: function() {
      return this.$vuetify.theme.themes.light.secondary
    },
    third: function() {
      return this.$vuetify.theme.themes.light.third
    },
    accent: function() {
      return this.$vuetify.theme.themes.light.accent
    },
    error: function() {
      return this.$vuetify.theme.themes.light.error
    },
    success: function() {
      return this.$vuetify.theme.themes.light.success
    },
    warning: function() {
      return this.$vuetify.theme.themes.light.warning
    },
    app_bar_title: function() {
      return this.$vuetify.theme.themes.light.app_bar_title
    },
    nav_title: function() {
      return this.$vuetify.theme.themes.light.nav_title
    },
    menu_title: function() {
      return this.$vuetify.theme.themes.light.menu_title
    },
    list_title: function() {
      return this.$vuetify.theme.themes.light.list_title
    },
    card_title: function() {
      return this.$vuetify.theme.themes.light.card_title
    },
    sub_title: function() {
      return this.$vuetify.theme.themes.light.sub_title
    },
    content: function() {
      return this.$vuetify.theme.themes.light.content
    },
    app_bar_bg: function() {
      return this.$vuetify.theme.themes.light.app_bar_bg
    },
    nav_bg: function() {
      return this.$vuetify.theme.themes.light.nav_bg
    },
    menu_bg: function() {
      return this.$vuetify.theme.themes.light.menu_bg
    },
    //2022-03-17 by lyj tabview테마적용 start
    tabview_bg: function() {
      return this.$vuetify.theme.themes.light.tabview_bg
    },
    tabview_active_text: function() {
      return this.$vuetify.theme.themes.light.tabview_active_text
    },
    tabview_text: function() {
      return this.$vuetify.theme.themes.light.tabview_text
    },
    //2022-03-17 by lyj tabview테마적용 end
    list_bg: function() {
      return this.$vuetify.theme.themes.light.list_bg
    },
    container_bg: function() {
      return this.$vuetify.theme.themes.light.container_bg
    },
    card_bg: function() {
      return this.$vuetify.theme.themes.light.card_bg
    },
    card_title_bg: function() {
      return this.$vuetify.theme.themes.light.card_title_bg
    },
    radioColor: function() {
      if (this.radioColorGroup == 'primary') {
        return 'ma-1 pa-1 primary--text'
      } else if (this.radioColorGroup == 'secondary') {
        return 'ma-1 pa-1 secondary--text'
      } else if (this.radioColorGroup == 'success') {
        return 'ma-1 pa-1 success--text'
      } else if (this.radioColorGroup == 'error') {
        return 'ma-1 pa-1 error--text'
      } else {
        return 'ma-1 pa-1 warning--text'
      }
    }
  },
  data() {
    return {
      selectList: ['One', 'Two', 'Three', 'Four'],
      checkbox: true,
      ex1: true,
      ex2: true,
      ex3: true,
      ex4: true,
      ex5: true,
      checkboxEnable: false,
      radioGroup: 1,
      radioColorGroup: 1,
      radios: null,
      pwShow: false,
      password: '',
      name: '',
      fullDialog: false,
      infoDialog: false,
      okcanDialog: false,
      loadingDialog: false
    }
  }
}
</script>
